import { StyleDeclarationValue } from 'aphrodite';
import { useEffect } from 'react';
import { CustomPageType } from '../../../extViewmodels/sdk/models/CustomPageStyle';
import { useCustomPageStyle } from '../../hooks/useCustomPageStyle';
import { applySchedulerAccentVars } from '../../styles/customBrandedAccents';
import { MeetingContainerView } from './MeetingContainerView';

interface IProps {
	cardStyles?: StyleDeclarationValue[];
	className?: string;
	contentStyles?: StyleDeclarationValue[];
	styles?: StyleDeclarationValue[];
	shortCode?: string;
	children: React.ReactNode;
}

export const MeetingContainer: React.FC<IProps> = ({
	cardStyles = [],
	children,
	className = '',
	contentStyles = [],
	styles = [],
	shortCode,
}) => {
	const {
		data: customHeaderData,
		hasCustomButtonColors,
		hasCustomContent: hasCustomHeader,
		inIframe,
	} = useCustomPageStyle(shortCode, CustomPageType.Header);
	const { data: customFooterData, hasCustomContent: hasCustomFooter } = useCustomPageStyle(
		shortCode,
		CustomPageType.Footer
	);

	useEffect(() => {
		if (!hasCustomButtonColors) {
			return;
		}
		// On body rather than this container's root because ScheduleMeetingErrorModal renders
		// outside MeetingContainer and must inherit these too.
		return applySchedulerAccentVars();
	}, [hasCustomButtonColors]);

	return (
		<MeetingContainerView
			cardStyles={cardStyles}
			className={className}
			contentStyles={contentStyles}
			customFooterHtml={inIframe ? undefined : customFooterData?.html}
			customHeaderHtml={inIframe ? undefined : customHeaderData?.html}
			hasCustomFooter={hasCustomFooter}
			hasCustomHeader={hasCustomHeader}
			styles={styles}
		>
			{children}
		</MeetingContainerView>
	);
};
